import { render, staticRenderFns } from "./CPInvestorAccordion.vue?vue&type=template&id=df8abcd2&scoped=true"
import script from "./CPInvestorAccordion.vue?vue&type=script&lang=js"
export * from "./CPInvestorAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8abcd2",
  null
  
)

export default component.exports